module.exports = __webpack_public_path__ + "media/images/mymp-icon-32af9488ef12482884b60f3a2bbaa031.svg";